<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns is-centered is-multiline">
          <div class="column is-3">
            <figure class="image">
              <img src="@/assets/img/logo.png">
            </figure>
          </div>
          <div class="column is-12"></div>
          <div class="column is-6">
            <b-notification type="is-primary" has-icon icon-pack="mdi">
              <strong>Su sesión ha expirado</strong>
              <br>Aguarde un instante mientras es redirigido
            </b-notification>
            <progress class="progress is-primary" max="100"></progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'SesionExpirada',
  methods: {
    ...mapMutations(['hideNavAndFooter', 'showNavAndFooter'])
  },
  mounted () {
    this.hideNavAndFooter()
    var componenteVue = this
    setTimeout(() => {
      componenteVue.$router.push({ name: 'login' })
    }, 4000)
  },
  beforeDestroy () {
    this.showNavAndFooter()
  }
}
</script>
